module.exports = __webpack_public_path__ + "img/252.d5a63fb1.jpg";